module.exports = __webpack_public_path__ + "static/media/SF-8-A.9e553e4b.mp3";